import React, { Component } from 'react';
import MobileMenuViewOne from './MobileMenuViewOne';
import MobileMenuViewTwo from './MobileMenuViewTwo';
import MobileMenuViewThree from './MobileMenuViewThree';
import { CATEGORIES_DROPDOWN } from '../../../../lib/constants';

class MobileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: 1, // Default to view one
      subCategories: [],
      shops: [],
      parentCategorySlug: '',
      parentCategoryAnalyticsSlug: '',
      parentCategoryName: '',
    };
    this.focusButton = {};
    this.setFocusButton = this.setFocusButton.bind(this);
    this.browseCategoriesOnClickHandler = this.browseCategoriesOnClickHandler.bind(this);
    this.backButtonOnClickHandler = this.backButtonOnClickHandler.bind(this);
    this.primaryCategoryOnClickHandler = this.primaryCategoryOnClickHandler.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.closed) {
      this.setState({ view: 1 });
      this.focusButton = {};
    }
  }

  componentDidUpdate() {
    const el = document.querySelector(`#${this.focusButton[this.state.view]}`)
    el && el.focus && el.focus();
  }

  browseCategoriesOnClickHandler(element) {
    this.setFocusButton(1, element.id, true);
    this.setState({ view: 2 });
  }

  primaryCategoryOnClickHandler(
    element,
    subCategories,
    shops,
    parentCategorySlug,
    parentCategoryAnalyticsSlug,
    parentCategoryName
  ) {
    this.setFocusButton(2, element.id, true);
    this.setState(
      {
        view: 3,
        subCategories,
        shops,
        parentCategorySlug,
        parentCategoryAnalyticsSlug,
        parentCategoryName,
      },
    );
  }

  backButtonOnClickHandler() {
    this.setFocusButton(this.state.view, null, true);
    const prevState = this.state.view - 1;
    this.setState({ view: prevState });
  }

  setFocusButton(view, id, force = false) {
    if (!this.focusButton[view] || force) {
      this.focusButton[view] = id;
    }
  }

  render() {
    const {
      locale,
      isUserLoggedIn,
      searchNavBarData = {},
      catNavBarData = {},
      pageStateModifiers = {},
      currentPath = '',
      localeUrls,
      subCategoryLocaleSlugMap,
      globalPageConfig,
      visitInfo,
      globalNavData = {},
      theme
    } = this.props;

    // get the Browse Categories nav slot
    let firstNavSlotRow = [];
    if (catNavBarData && catNavBarData.firstNavSlots && catNavBarData.anonFirstNavSlots) {
      firstNavSlotRow = isUserLoggedIn() ?
        catNavBarData.firstNavSlots : catNavBarData.anonFirstNavSlots;
    }

    // Select only the first instance of categories dropdown
    let browseCategoriesNavSlot = firstNavSlotRow && firstNavSlotRow.length ?
      firstNavSlotRow.filter(slot => slot.navSlotPurpose === CATEGORIES_DROPDOWN) : null;
    browseCategoriesNavSlot = browseCategoriesNavSlot && browseCategoriesNavSlot.length ?
      browseCategoriesNavSlot[0] : null;

    const linkOneUrl = catNavBarData && catNavBarData.linkOneUrl ? catNavBarData.linkOneUrl : '';
    const linkOneText = catNavBarData && catNavBarData.linkOneText ? catNavBarData.linkOneText : '';
    const linkOneAnalyticsSlug = catNavBarData?.linkOneAnalyticsSlug ?? '';
    const linkTwoUrl = catNavBarData && catNavBarData.linkTwoUrl ? catNavBarData.linkTwoUrl : '';
    const linkTwoText = catNavBarData && catNavBarData.linkTwoText ? catNavBarData.linkTwoText : '';
    const linkTwoAnalyticsSlug = catNavBarData?.linkTwoAnalyticsSlug ?? '';

    const mobileMenuViewOne = (
      <MobileMenuViewOne
        visitInfo={visitInfo}
        isUserLoggedIn={isUserLoggedIn}
        catNavBarData={catNavBarData}
        searchNavBarData={searchNavBarData}
        globalNavData={globalNavData}
        locale={locale}
        browseCategoriesOnClick={this.browseCategoriesOnClickHandler}
        pageStateModifiers={pageStateModifiers}
        currentPath={currentPath}
        localeUrls={localeUrls}
        subCategoryLocaleSlugMap={subCategoryLocaleSlugMap}
        view={this.state.view}
        theme={theme}
        setFocusButton={this.setFocusButton}
        globalPageConfig={globalPageConfig}
      />
    );

    const mobileMenuViewTwo = (
      <MobileMenuViewTwo
        locale={locale}
        backButtonOnClick={this.backButtonOnClickHandler}
        primaryCategoryOnClick={this.primaryCategoryOnClickHandler}
        browseCategoriesNavSlot={browseCategoriesNavSlot}
        linkOneUrl={linkOneUrl}
        linkOneText={linkOneText}
        linkOneAnalyticsSlug={linkOneAnalyticsSlug}
        linkTwoUrl={linkTwoUrl}
        linkTwoText={linkTwoText}
        linkTwoAnalyticsSlug={linkTwoAnalyticsSlug}
        view={this.state.view}
        theme={theme}
        parentCategorySlug={this.state.parentCategorySlug}
        globalPageConfig={globalPageConfig}
        setFocusButton={this.setFocusButton}
      />
    );

    const mobileMenuViewThree = (
      <MobileMenuViewThree
        locale={locale}
        subCategories={this.state.subCategories}
        shops={this.state.shops}
        parentCategorySlug={this.state.parentCategorySlug}
        parentCategoryAnalyticsSlug={this.state.parentCategoryAnalyticsSlug}
        parentCategoryName={this.state.parentCategoryName}
        backButtonOnClick={this.backButtonOnClickHandler}
        browseCategoriesNavSlot={browseCategoriesNavSlot}
        globalPageConfig={globalPageConfig}
        setFocusButton={this.setFocusButton}
        theme={theme}
      />
    );

    let finalView = mobileMenuViewOne;

    switch (this.state.view) {
      case 1:
        finalView = mobileMenuViewOne;
        break;
      case 2:
        finalView = mobileMenuViewTwo;
        break;
      case 3:
        finalView = mobileMenuViewThree;
        break;
      default:
        finalView = mobileMenuViewOne;
        break;
    }

    return (finalView);
  }
}

export default MobileMenu;
